import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Loader, RoutesInternal } from 'theSource/components';
import { DecisionIQ } from './DecisionIQ';
import { BundledBenefits } from './BundledBenefits';
import { selectProfileSteps } from 'enrollment/components/BottomNavigation/services';
import { BundledBenefitsLoader } from './BundledBenefits/BundledBenefitsLoader';

export const DecisionSupportServices = () => {
  const pages = useSelector(selectProfileSteps);
  const decisionSupportPage = pages.decisionSupport;

  if (decisionSupportPage) {
    if (decisionSupportPage === 'decisioniq') {
      return (
        <RoutesInternal>
          <Route index element={<DecisionIQ />} />
        </RoutesInternal>
      );
    } else if (decisionSupportPage === 'bundles') {
      return (
        <RoutesInternal>
          <Route index element={<BundledBenefits />} />
          <Route path="/complete" element={<BundledBenefitsLoader />} />
        </RoutesInternal>
      );
    }
  }
  return <Loader />;
};
